async function loadOptions(prefix, selects) {
    return new Promise((resolve) => {
        var options = null;
        var optionsStr = sessionStorage.getItem(prefix + "-options");
        if (typeof optionsStr != "undefined" && optionsStr != null && optionsStr != "null") {
            options = JSON.parse(optionsStr);
        }

        var selectOptions = [];
        if (Array.isArray(selects) && selects.length > 0) {
            selects.forEach(select => {
                var selected = sessionStorage.getItem(prefix + "-" + select);
                if (
                    typeof selected != "undefined" &&
                    selected != null &&
                    selected != "null"
                )
                    selectOptions.push({
                        key: select,
                        value: JSON.parse(selected)
                    });
            });
        }

        resolve({
            options: options,
            selecteds: selectOptions
        });
    });
}

export default {
    loadOptions
}